import * as React from 'react'

const SvgNotificationFilledIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width={20} height={20} viewBox="0 0 20 20" fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17.938 12.688L16.25 11V8.125a6.294 6.294 0 00-5.625-6.25V.625h-1.25v1.25a6.344 6.344 0 00-5.625 6.25V11l-1.688 1.688a.569.569 0 00-.187.437V15a.588.588 0 00.625.625h4.375a3.125 3.125 0 106.25 0H17.5a.588.588 0 00.625-.625v-1.875a.568.568 0 00-.188-.438zM10 17.5a1.875 1.875 0 01-1.875-1.875h3.75c0 1.035-.84 1.875-1.875 1.875z"
      fill="#163250"
    />
  </svg>
)

export default SvgNotificationFilledIcon
